import axios from "axios"
import { useEffect, useState } from "react"
import { BRANCHES_API, ORGANIZATIONS_API } from "../../../../Utilities/APIs"
import Form from "../../../Partials/Layouts/Forms/Form"
import ImageInput from "../../../Partials/Layouts/Forms/FormInputs/ImageInput/ImageInput"
import LongTextInput from "../../../Partials/Layouts/Forms/FormInputs/LongTextInput/LongTextInput"
import SelectInput from "../../../Partials/Layouts/Forms/FormInputs/SelectInput/SelectInput"
import SelectOption from "../../../Partials/Layouts/Forms/FormInputs/SelectInput/SelectOption/SelectOption"
import ShortTextInput from "../../../Partials/Layouts/Forms/FormInputs/ShortTextInput/ShortTextInput"
import FormSubmitButton from "../../../Partials/Layouts/Forms/FormSubmitButton/FormSubmitButton"


function UpdateBranch({ employee, setShowUpdateForm, setShowModal, triggerFetch, organizationID, targetID }) {

  // console.log(organizationID)

  const [singleOrganization, setSingleOrganization] = useState(null)
  // console.log(singleOrganization)

  const [organization, setOrganization] = useState(organizationID)
  const [name, setName] = useState('')
  const [branchPhoneNumber, setBranchPhoneNumber] = useState('')
  const [branchAddress, setBranchAddress] = useState('')
  const [mapLocation, setMapLocation] = useState('')
  const [image, setImage] = useState('')

  useEffect(() => {
    async function getAndSetSingleOrganization() {
      const { data } = await axios.get(ORGANIZATIONS_API + organizationID)
      // console.log(data)
      setSingleOrganization(data)
    }

    getAndSetSingleOrganization()
  }, [organizationID])

  //set field value
  useEffect(() => {
    const config = {
      headers: {
        Authorization: `Bearer ${employee.token}`
      }
    }


    async function getAndSetSingleBranch() {
      const { data } = await axios.get(BRANCHES_API + targetID, config)
      console.log(data)
      setName(data.name)
      setBranchPhoneNumber(data.branchPhoneNumber)
      setBranchAddress(data.branchAddress)
      setMapLocation(data.mapLocation)
      setImage(data.image)
    }
    getAndSetSingleBranch()
  }, [employee.token, targetID])


  //form submit function
  async function handleSubmit(e) {

    e.preventDefault()

    const config = {
      headers: {
        Authorization: `Bearer ${employee.token}`
      }
    }

    const itemData = new FormData()

    itemData.append('organization', organization)
    itemData.append('name', name)
    itemData.append('branchPhoneNumber', branchPhoneNumber)
    itemData.append('branchAddress', branchAddress)
    itemData.append('mapLocation', mapLocation)
    itemData.append('image', image)

    console.log(itemData)

    const response = await axios.put(BRANCHES_API + targetID, itemData, config)

    if (response) {
      setOrganization('')
      setName('')
      setBranchPhoneNumber('')
      setBranchAddress('')
      setMapLocation('')
      setImage('')

      setShowUpdateForm(false);
      setShowModal(false);
      console.log(response)
      triggerFetch()
    }

  }


  return (
    <Form onSubmit={handleSubmit} hasImage>
      <SelectInput value={organization} setState={setOrganization}>
        <SelectOption optionValue={organizationID} optionText={singleOrganization?.name} />
      </SelectInput>
      <ShortTextInput
        label='Name'
        value={name}
        placeholder={`Enter Name`}
        setState={setName}
      />
      <ShortTextInput
        label={`Phone`}
        value={branchPhoneNumber}
        placeholder={`Enter Phone Number`}
        setState={setBranchPhoneNumber}
      />
      <LongTextInput
        label={`Address`}
        value={branchAddress}
        placeholder={`Enter Branch Address`}
        setState={setBranchAddress}
      />
      <LongTextInput
        label={`Map Location`}
        value={mapLocation}
        placeholder={`Enter Map Location`}
        setState={setMapLocation}
      />

      <ImageInput fieldId='1' state={image} setState={setImage} allowUpdateImage>Upload Card Image</ImageInput>

      <FormSubmitButton text='Update Branch' />
    </Form>
  )
}

export default UpdateBranch